import { idUser } from "./getters";

const defaultState = {
  name: null,
  role: null,
  login: null,
  fullName: null,
  id: null
};

export default defaultState;
